'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Users = void 0;
var tslib_1 = require("tslib");
var transport_1 = require("../../transport");
var signup_1 = require("./signup");
var getAmlStatus_1 = require("./getAmlStatus");
var util_1 = require("../../util");
var Users = /** @class */ (function () {
    function Users() {
    }
    Users.prototype.addNote = function (params) {
        return transport_1.transport.request('users/addNote', params);
    };
    Users.prototype.acknowledgeMessage = function (params) {
        return transport_1.transport.request('message/acknowledgeMessage', params);
    };
    Users.prototype.subscribe = function (params) {
        return transport_1.transport.subscribe(params);
    };
    Users.prototype.unsubscribe = function (params) {
        return transport_1.transport.unsubscribe(params);
    };
    Users.prototype.agreedCompliance = function (params) {
        return transport_1.transport.request('users/agreedCompliance', params);
    };
    Users.prototype.getProfileV2 = function () {
        return transport_1.transport.request('users/getProfileV2');
    };
    Users.prototype.getProfile = function () {
        return transport_1.transport.request('users/getProfile');
    };
    Users.prototype.updateProfile = function (params) {
        return transport_1.transport.request('users/updateProfile', params);
    };
    Users.prototype.updateProfileV2 = function (params) {
        return transport_1.transport.request('users/updateProfileV2', params);
    };
    Users.prototype.triggerKYCVerificationsRequest = function (params) {
        return transport_1.transport.request('corex/trigger-verifications', params);
    };
    Users.prototype.getBankIdiFrameDetails = function (params) {
        return transport_1.transport
            .request('users/getBankIdiFrameDetails', params)
            .then(function (payload) { return payload.redirectOutput || payload; });
    };
    Users.prototype.getSportncoLaunchURL = function (params) {
        return transport_1.transport.request('users/getSportncoLaunchURL', params);
    };
    Users.prototype.getSportncoDemoLaunchURL = function (params) {
        return transport_1.transport.request('corex/get-demo-launch-sportsbook', params);
    };
    Users.prototype.getSportncoLaunchURLCoreX = function (params) {
        return transport_1.transport.request('corex/get-launch-sportsbook', params);
    };
    Users.prototype.getSportncoToken = function () {
        return transport_1.transport.request('users/getSportncoToken');
    };
    Users.prototype.resendVerificationEmail = function (params) {
        return transport_1.transport.request('signup/sendVerifyEmail', params);
    };
    Users.prototype.signup = function (params, lang, quick, transparentErrors, geoResponse) {
        if (quick === void 0) { quick = false; }
        if (transparentErrors === void 0) { transparentErrors = false; }
        var userConsents = params.userConsents, authModel = tslib_1.__rest(params, ["userConsents"]);
        var endpoint = signup_1.SignUpEndpoint.SignUpV2;
        if (params.signUpEndpoint) {
            endpoint = params.signUpEndpoint;
        }
        else if (quick) {
            endpoint = signup_1.SignUpEndpoint.QuickSignUpV2;
        }
        else {
            var hasLicenceNo = authModel.driversLicenceNo !== undefined;
            var hasLicenceVer = authModel.driversLicenceVersion !== undefined;
            var hasPassportNo = authModel.passportNo !== undefined;
            var hasPassportExpiry = authModel.passportExpiry !== undefined;
            var hasLotbaFields = this.hasLotbaFields(authModel);
            var hasAGCOFields = this.hasAGCOFields(authModel);
            if (hasAGCOFields) {
                endpoint = signup_1.SignUpEndpoint.SignUpAGCO;
                this.replaceField(authModel, 'firstname', 'firstName');
                this.replaceField(authModel, 'surname', 'lastName');
                this.replaceField(authModel, 'verificationTypeID', 'verificationType');
                this.replaceField(authModel, 'lang', 'languageAlpha2Code');
            }
            if ((hasLicenceNo && hasLicenceVer) ||
                (hasPassportNo && hasPassportExpiry)) {
                endpoint = signup_1.SignUpEndpoint.SignUpV2SC;
            }
            if (hasLotbaFields) {
                endpoint = signup_1.SignUpEndpoint.SignUpLOTBA;
            }
        }
        var data = {
            authModel: authModel,
            userConsents: userConsents,
            lang: lang,
            transparentErrors: transparentErrors,
        };
        return transport_1.transport.request(endpoint, geoResponse ? tslib_1.__assign(tslib_1.__assign({}, data), { geoResponse: geoResponse }) : data);
    };
    Users.prototype.signupV2 = function (params) {
        var userConsents = params.userConsents, signUpEndpoint = params.signUpEndpoint, lang = params.lang, authModel = tslib_1.__rest(params, ["userConsents", "signUpEndpoint", "lang"]);
        var endpoint = signUpEndpoint !== null && signUpEndpoint !== void 0 ? signUpEndpoint : signup_1.SignUpEndpoint.SignUpV2;
        var data = {
            authModel: authModel,
            userConsents: userConsents,
            lang: lang,
            transparentErrors: false,
        };
        return transport_1.transport.request(endpoint, data);
    };
    Users.prototype.replaceField = function (authModel, oldField, newField) {
        authModel[newField] = authModel[oldField];
        delete authModel[oldField];
    };
    Users.prototype.getCountries = function () {
        return transport_1.transport.request('signup/getCountries');
    };
    Users.prototype.impersonate = function (token) {
        return transport_1.transport.request('users/impersonate', token);
    };
    Users.prototype.login = function (params) {
        return transport_1.transport.request('users/login', params);
    };
    Users.prototype.loginV2 = function (params) {
        return transport_1.transport.request('users/loginV2', params);
    };
    Users.prototype.resumeLogin = function () {
        return transport_1.transport.request('users/resumeLogin');
    };
    Users.prototype.resumeLoginV2 = function () {
        return transport_1.transport.request('users/resumeLoginV2');
    };
    Users.prototype.getUserProfile = function () {
        return transport_1.transport.request('corex/get-user-profile');
    };
    Users.prototype.getUserDocuments = function () {
        return transport_1.transport.request('corex/get-user-documents');
    };
    Users.prototype.getUserVerificationURL = function (params) {
        return transport_1.transport.request('corex/get-user-verification-url', params);
    };
    Users.prototype.isLoggedIn = function () {
        return transport_1.transport.request('users/isLoggedIn');
    };
    Users.prototype.authenticateWithChallengeToken = function (params) {
        return transport_1.transport.request('users/authenticateWithChallengeToken', params);
    };
    Users.prototype.completeRegistration = function (params) {
        return transport_1.transport.request('users/completeRegistration', params);
    };
    Users.prototype.logout = function () {
        return transport_1.transport.request('users/logout');
    };
    Users.prototype.hasPendingConsents = function () {
        return transport_1.transport.request('users/hasPendingConsents');
    };
    Users.prototype.userPendingConsents = function (params) {
        return transport_1.transport.request('users/userPendingConsents', params);
    };
    Users.prototype.resetPasswordRequestV1 = function (params) {
        return transport_1.transport.request('users/sendResetPwdEmail', params);
    };
    Users.prototype.resetPasswordRequest = function (params) {
        return transport_1.transport.request('users/sendResetPwdEmailV2', params);
    };
    Users.prototype.resetPassword = function (params) {
        return transport_1.transport.request('users/resetPassword', params);
    };
    Users.prototype.sendResetPwdSMS = function (params) {
        return transport_1.transport.request('users/sendResetPwdSMS', params);
    };
    Users.prototype.resetPasswordSMS = function (params) {
        return transport_1.transport.request('users/resetPasswordSMS', params);
    };
    Users.prototype.bonus = function (params) {
        return transport_1.transport.request('users/bonus', params);
    };
    Users.prototype.verifyEmail = function (params) {
        return transport_1.transport.request('users/verifyEmail', params);
    };
    Users.prototype.getSOWQ = function () {
        return transport_1.transport.request('users/getSOWQ');
    };
    Users.prototype.postSOWQ = function (params) {
        return transport_1.transport.request('users/postSOWQ', params);
    };
    Users.prototype.getIdDocTypes = function () {
        return transport_1.transport.request('users/getIdDocTypes');
    };
    Users.prototype.getAmlVerificationStatus = function () {
        return transport_1.transport.request('users/getAmlVerificationStatus');
    };
    Users.prototype.getGracePeriod = function () {
        return transport_1.transport.request('users/getGracePeriod');
    };
    Users.prototype.sessionTurnover = function () {
        return transport_1.transport.request('users/sessionTurnover');
    };
    Users.prototype.getPreferences = function () {
        return transport_1.transport.request('users/getPreferences');
    };
    /**
     * 16666.65 is the value used as "disabled"
     * but is not returned correctly in all cases
     * depending on user jurisdiction
     */
    Users.prototype.getRealityCheckOptions = function () {
        return transport_1.transport
            .request('users/getRealityCheckOptions')
            .then(function (payload) { return (tslib_1.__assign(tslib_1.__assign({}, payload), { availableValues: payload.availableValues.filter(function (value) {
                return value !== "" + util_1.REALITY_CHECK_DISABLED_VALUE;
            }) })); });
    };
    Users.prototype.setPreferences = function (params) {
        return transport_1.transport.request('users/setPreferences', {
            preference: params,
        });
    };
    Users.prototype.setRealityCheck = function (params) {
        return transport_1.transport.request('users/setRealityCheck', params);
    };
    Users.prototype.getRealityCheck = function () {
        return transport_1.transport.request('users/getRealityCheck');
    };
    Users.prototype.continueRealityCheckCoreX = function (params) {
        return transport_1.transport.request('corex/continue-user-reality-check', params);
    };
    Users.prototype.stopRealityCheckCoreX = function (params) {
        return transport_1.transport.request('corex/stop-user-reality-check', params);
    };
    Users.prototype.getPendingRealityCheckCoreX = function () {
        return transport_1.transport.request('corex/get-pending-reality-check');
    };
    Users.prototype.getLoginHistory = function (params) {
        return transport_1.transport.request('users/getLoginHistory', params);
    };
    Users.prototype.getConsents = function (params) {
        return transport_1.transport.request('users/getConsents', params);
    };
    Users.prototype.getUserConsents = function (params) {
        return transport_1.transport.request('users/userConsents', params);
    };
    Users.prototype.saveUserConsents = function (params) {
        return transport_1.transport.request('users/saveUserConsents', params);
    };
    Users.prototype.detailsUpdateRequest = function () {
        return transport_1.transport.request('users/detailsUpdateRequested');
    };
    Users.prototype.updateUserProfile = function (params) {
        return transport_1.transport.request('corex/update-user-profile', params);
    };
    Users.prototype.setUserOnSiteMarketing = function (params) {
        return transport_1.transport.request('users/setUserOnSiteMarketing', params);
    };
    Users.prototype.getTotalRedemptionAmount = function () {
        return transport_1.transport.request('corex/get-user-total-redemption-amount');
    };
    Users.prototype.cancelRedeemSweepcoins = function () {
        return transport_1.transport.request('corex/cancel-redeem-sweepcoins');
    };
    Users.prototype.changePassword = function (params) {
        return transport_1.transport.request('users/changePassword', params);
    };
    Users.prototype.changeEmail = function (params) {
        return transport_1.transport.request('users/changeEmail', params);
    };
    Users.prototype.closeAccount = function (params) {
        return transport_1.transport.request('users/closeAccount', params);
    };
    Users.prototype.closeAccountV2 = function (params) {
        return transport_1.transport.request('users/closeAccountV2', params);
    };
    Users.prototype.closeAccountCorex = function (params) {
        return transport_1.transport.request('corex/create-user-restriction', params);
    };
    Users.prototype.getUserQuestionnaires = function (params) {
        return transport_1.transport.request('corex/get-user-questionnaires', params);
    };
    Users.prototype.getQuestionnaireTemplate = function (params) {
        return transport_1.transport.request('corex/get-questionnaire-template', params);
    };
    Users.prototype.getSubmitQuestionnaire = function (params) {
        return transport_1.transport.request('corex/submit-user-questionnaire', params);
    };
    Users.prototype.verifySMS = function (params) {
        return transport_1.transport.request('signup/verifySMS', params);
    };
    Users.prototype.isEmailAvailable = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, transport_1.transport.request('signup/checkEmail', params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.isAvailable];
                }
            });
        });
    };
    Users.prototype.isUsernameAvailable = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, transport_1.transport.request('signup/checkUsername', params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.isAvailable];
                }
            });
        });
    };
    Users.prototype.getAmlStatus = function () {
        return transport_1.transport.request('users/getAMLStatus');
    };
    Users.prototype.getPepDetails = function () {
        return transport_1.transport.request('signup/retrievePepAdditionalDetails');
    };
    Users.prototype.savePepDetails = function (params) {
        return transport_1.transport.request('signup/savePepAdditionalDetails', params);
    };
    Users.prototype.uploadKYC = function (params) {
        return this.uploadKycRequest(params, 'uploadKYC');
    };
    Users.prototype.requestAndUploadKYC = function (params) {
        // TODO: Switch to `uploadKycRequest` method once backend supports
        // doctype additional data.
        return transport_1.transport.uploadFiles('requestAndUploadKYC', params.files || params.file, params.onProgressChange, {
            documentType: params.type,
        });
    };
    Users.prototype.updateLanguage = function (lang) {
        return transport_1.transport.request('users/setLanguage', { lang: lang });
    };
    Users.prototype.kycDocumentRequest = function (params) {
        return transport_1.transport.request('users/kycDocumentRequest', params);
    };
    Users.prototype.verifyWithDataZoo = function (params) {
        return transport_1.transport.request('users/verifyWithDataZoo', params);
    };
    Users.prototype.listSecurityQuestions = function () {
        return transport_1.transport.request('users/listSecurityQuestions');
    };
    Users.prototype.changeSecurityQuestion = function (params) {
        return transport_1.transport.request('users/changeSecurityQuestionV2', params);
    };
    Users.prototype.getSecurityQuestions = function (params) {
        return transport_1.transport.request('users/getSecurityQuestionV2', params);
    };
    Users.prototype.getUserActiveBlocks = function () {
        return transport_1.transport.request('users/getUserActiveBlocks');
    };
    Users.prototype.getKycVerificationUrl = function () {
        return transport_1.transport.request('users/getkycverificationurl');
    };
    Users.prototype.notificationMessage = function (params) {
        return transport_1.transport.request('users/notificationMessage', params);
    };
    Users.prototype.linkSlotboxLandBaseUser = function () {
        return transport_1.transport.request('users/linkSlotboxLandBaseUser');
    };
    Users.prototype.getOmniUserDetails = function () {
        return transport_1.transport.request('users/getOmniUserDetails');
    };
    Users.prototype.getAuthenticationMethod = function () {
        return transport_1.transport.request('users/getAuthenticationMethod');
    };
    Users.prototype.setAuthenticationMethod = function (params) {
        return transport_1.transport.request('users/setAuthenticationMethod', params);
    };
    Users.prototype.sendSMS = function () {
        return transport_1.transport.request('users/sendSMS');
    };
    Users.prototype.getGameSessionSummary = function () {
        return transport_1.transport.request('users/getGameSessionSummary');
    };
    Users.prototype.signUpDGE = function (authModel, lang, userConsents) {
        var data = {
            authModel: authModel,
            userConsents: userConsents,
            lang: lang,
        };
        return transport_1.transport.request('users/signUpDGE', data);
    };
    Users.prototype.signUpONJN = function (authModel, lang, userConsents) {
        var data = {
            authModel: authModel,
            userConsents: userConsents,
            lang: lang,
        };
        return transport_1.transport.request('users/signUpONJN', data);
    };
    Users.prototype.getKBAQuestions = function () {
        return transport_1.transport.request('users/getKBAQuestions');
    };
    Users.prototype.verifyKBAAnswers = function (answeredQuestionnaire) {
        return transport_1.transport.request('users/verifyKBAAnswers', answeredQuestionnaire);
    };
    Users.prototype.getScanVerifyUrl = function () {
        return transport_1.transport.request('users/getScanVerifyUrl');
    };
    Users.prototype.linkLandBased = function () {
        return transport_1.transport.request('users/linkLandBased');
    };
    Users.prototype.membershipRegistration = function (params) {
        return transport_1.transport.request('users/membershipNumberRegistration', params);
    };
    Users.prototype.getAGCODetails = function () {
        return transport_1.transport.request('users/getAGCODetails');
    };
    Users.prototype.getMagicProfileCoreX = function () {
        return transport_1.transport.request('users/getMagicProfile');
    };
    Users.prototype.getUserRealityCheckConfigs = function () {
        return transport_1.transport.request('corex/get-user-reality-check-configs');
    };
    Users.prototype.setUserRealityCheckInterval = function (params) {
        return transport_1.transport.request('corex/set-user-reality-check-interval', params);
    };
    Users.prototype.getUserTransactionsHistory = function (params) {
        return transport_1.transport.request('corex/get-user-transactions-history', params);
    };
    Users.prototype.getSweepxTransactionsHistory = function (params) {
        return transport_1.transport.request('corex/get-sweepstakes-monetary-transactions-history', params);
    };
    Users.prototype.getUserBonusesTransactionsHistory = function (params) {
        return transport_1.transport.request('corex/get-all-user-bonuses', params);
    };
    Users.prototype.getMailInCode = function () {
        return transport_1.transport.request('users/get-mail-in-code');
    };
    Users.prototype.uploadKycRequest = function (params, endpoint) {
        var additionalParams = {
            type: params.type,
        };
        if (params.type === getAmlStatus_1.DocumentType.PHOTO_ID && params.docType) {
            additionalParams.docType = params.docType;
        }
        if (params.type === getAmlStatus_1.DocumentType.SOURCE_OF_WEALTH_DOCUMENTS &&
            params.SOWDType) {
            additionalParams.SOWDType = params.SOWDType;
        }
        return transport_1.transport.uploadFiles(endpoint, params.files || params.file, params.onProgressChange, additionalParams);
    };
    /**
     * Check if user registration model contains fields that are LOTBA specific.
     * Extend/change this check depending on the needs.
     *
     * @param userModel
     * @returns boolean true if the user model contains LOTBA specific fields
     */
    Users.prototype.hasLotbaFields = function (userModel) {
        return !!(userModel.identificationNumber && userModel.nationalityCode);
    };
    Users.prototype.hasAGCOFields = function (userModel) {
        return !!('employerCountryAlpha2Code' in userModel &&
            'employerIsoCodeSubdivision1' in userModel);
    };
    Users.prototype.resendUserVerification = function (params) {
        return transport_1.transport.request('corex/resend-user-verification', params);
    };
    return Users;
}());
exports.Users = Users;
